import { render, staticRenderFns } from "./inpatienttreatment.vue?vue&type=template&id=00185775&scoped=true"
import script from "./inpatienttreatment.vue?vue&type=script&lang=js"
export * from "./inpatienttreatment.vue?vue&type=script&lang=js"
import style0 from "./inpatienttreatment.vue?vue&type=style&index=0&id=00185775&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00185775",
  null
  
)

export default component.exports